module.exports = "/_next/static/images/bb07243b44ecb6dfa20932ab6009b249-pj-phone-and-business-card@0.5x.jpg.webp";